import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import Clients from './Clients.vue'
import Admin from './Admin.vue'
import vuetify from './plugins/vuetify'
import excel from 'vue-excel-export'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

 
Vue.use(excel)
Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', redirect: '/clients' },
    {path:'/admin',component:Admin},
    {path:'/clients',component:Clients},
    {path: '/logout'}
  ]
})

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
